var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPalletPackaging(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 24 24",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.5 24h-4a.5.5 0 01-.5-.5V22h-4v1.5a.5.5 0 01-.5.5h-5a.5.5 0 01-.5-.5V22H5v1.5a.5.5 0 01-.5.5h-4a.5.5 0 01-.5-.5v-5a.5.5 0 01.5-.5h23a.5.5 0 01.5.5v5a.5.5 0 01-.5.5zM20 23h3v-4H1v4h3v-1.5a.5.5 0 01.5-.5h5a.5.5 0 01.5.5V23h4v-1.5a.5.5 0 01.5-.5h5a.5.5 0 01.5.5zM12 13a.5.5 0 01-.5-.5v-9a.5.5 0 011 0v9a.5.5 0 01-.5.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 13a.502.502 0 01-.354-.146l-4-4a.5.5 0 01.707-.707L12 11.793l3.646-3.646a.5.5 0 01.707.707l-4 4A.498.498 0 0112 13z"
  })));
}

export default SvgPalletPackaging;